import React from 'react';
import { Col, Row } from 'react-bootstrap';

class GeneralInfo extends React.PureComponent {
  render() {
    return (
      <Row>
        <Col sm={6}>
          <strong>Launch Date:</strong>
          <span className="pull-right">10/07/2019</span>
        </Col>
        <Col sm={6}>
          <strong>Version:</strong>
          <span className="pull-right">1.2.3</span>
        </Col>
        <Col sm={6}>
          <strong>Primary Contact</strong>
          <span className="pull-right">somebody</span>
        </Col>
        <Col sm={6}>
          <strong>Secondary Contact</strong>
          <span className="pull-right">other one</span>
        </Col>
      </Row>
    );
  }
}

export default GeneralInfo;
